import {
  LoadItemOptions,
  ProviderHandlerConfig,
  setItemLoadState,
} from '@trimble/data-loading';
import { t } from '@trimble/i18n';
import { NotificationEventBus } from '@trimble/solidjs-notifications';
import { loadGaussianSplat } from '../content-loaders/gaussian-splat';
import { GaussianSplatCapabilityProvider } from '../gaussian-splat/GaussianSplatCapabilityProvider';
import { SplatsApiService } from '../splats/splats-api-service';
import { GaussianSplatItem, ProjectDataState } from './DataStateModels';

export const createGaussianSplatConfig = (
  splatsApi: SplatsApiService,
  getTenantTrn: () => string | undefined
): ProviderHandlerConfig<
  GaussianSplatCapabilityProvider,
  GaussianSplatItem,
  ProjectDataState
> => ({
  isProviderType: (provider): provider is GaussianSplatCapabilityProvider =>
    provider instanceof GaussianSplatCapabilityProvider,

  getLoadableItems: (loadableData: ProjectDataState) =>
    loadableData.gaussianSplat,

  loadItem: async (
    provider: GaussianSplatCapabilityProvider,
    item: GaussianSplatItem,
    options: LoadItemOptions
  ) => {
    const tenantTrn = getTenantTrn();
    if (!tenantTrn) {
      throw new Error('No tenant TRN available for Gaussian splat loading');
    }

    await loadGaussianSplat(
      item,
      splatsApi,
      tenantTrn,
      provider,
      options.reload ?? false,
      options.signal
    );
  },

  unloadItem: async (
    provider: GaussianSplatCapabilityProvider,
    item: GaussianSplatItem
  ) => {
    await provider.unloadTileset(item.id);
  },

  setLoadState: setItemLoadState<ProjectDataState>('gaussianSplat'),

  onLoadError: () => {
    NotificationEventBus.emit({
      type: 'error',
      message: t('mobileMapping.projectData.gaussianSplatLoadFailed'),
    });
  },
});
